
















































import { deepMerge } from '@empathybroker/deep-merge';
import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';

import { mapGetters } from 'vuex';

import { AlignEnum, FilterTypeEnum } from '../../enums';

import { Dictionary, Filter, RegularFilter, RegularFilterSelectedValues } from '../../models';

import { CONTEXT_CONSTS } from '../../store/context/context.consts';

import Badge from '../badge.component.vue';
import DataTable from '../crud/data-table.component.vue';
import Schedule from '../crud/schedule.component.vue';
import RegularFilterSelector from '../filters/regular-filter-selector.component.vue';
import { UiButton, UiDatepicker, UiSwitch } from '../keen-ui';

export default {
  name: 'edit-products-form',
  components: {
    Badge,
    DataTable,
    RegularFilterSelector,
    UiButton,
    UiDatepicker,
    UiSwitch,
    Schedule
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    })
  },
  created: function () {
    this.productsSelected = this.products.map(product => deepMerge({}, product));
    this.products.map((product, index) => {
      Object.keys(product.schedule).forEach(scheduleKey => {
        this.productsSelected[index].schedule[scheduleKey] = this.products[index].schedule[scheduleKey];
      });
    });
    const initFilters: Dictionary<Filter> = {};
    Object.values(this.context.filters)
      .filter((filter: Filter) => ((filter.config.type === FilterTypeEnum.REGULAR) &&
        (((filter as RegularFilter).config.toolingId || filter.config.id) !== 'lang')))
      .forEach((filter: RegularFilter) => {
        initFilters[(filter.config.toolingId || filter.config.id)] = {
          config: {
            ...filter.config,
            multiselectDisabled: false
          },
          selectedValues: this.getInitSelectedValues('filters', (filter.config.toolingId || filter.config.id))
        };
      });
    this.updates.filters = initFilters;
    this.updates.schedule.activationDate = this.getInitSelectedValues('schedule', 'activationDate');
    this.updates.schedule.deactivationDate = this.getInitSelectedValues('schedule', 'deactivationDate');
  },
  data: function () {
    const messages = this.$epb.messages.tools.productsRanking;

    return {
      columns: [
        {
          id: 'name',
          text: messages.fields.name.label
        }, {
          id: 'fieldValue',
          text: messages.fields.fieldValue.label,
          width: '10rem'
        }, {
          id: 'filters',
          text: messages.fields.filters.label,
          width: '6rem'
        }, {
          id: 'schedule',
          text: messages.fields.schedule.label,
          width: '6rem'
        }, {
          id: 'imageUrl',
          text: messages.fields.imageUrl.label,
          width: '8rem',
          align: AlignEnum.CENTER
        }
      ],
      updates: {
        filters: {},
        schedule: {
          activationDate: undefined,
          deactivationDate: undefined
        }
      },
      productsSelected: [],
      messages: messages
    };
  },
  methods: {
    onAccept: function (): void {
      this.$emit('update:products', this.productsSelected);
      this.$emit('close');
    },
    onFilterChange: function (filter: RegularFilter, selectedValues: RegularFilterSelectedValues): void {
      const itemfilterValues = selectedValues.map((selectedValue: string) => {
        const selectedValueConfig = filter.config.values.find((filterValueConfig: RegularFilterValueConfig) =>
          (filterValueConfig.id === selectedValue));
        return (selectedValueConfig.taggingId || selectedValueConfig.id);
      });
      this.updates.filters[(filter.config.toolingId || filter.config.id)].selectedValues =
        (filter.config.multiselectDisabled ? itemfilterValues[0] : itemfilterValues);
    },
    getInitSelectedValues(field: string, filterId: string) {
      const productsFilters = this.productsSelected.map(product => product[field][filterId]);
      const sample = productsFilters[0];
      if (!!sample && productsFilters.every(productFilters => JSON.stringify(productFilters) === JSON.stringify(sample))) {
        return sample;
      }
      return (field === 'schedule') ? undefined : [];
    }
  },
  props: {
    products: Array
  },
  watch: {
    'updates': {
      handler: function (): void {
        Object.values(this.updates.filters).map((filter: RegularFilter) => {
          this.productsSelected.map(product => product.filters[(filter.config.toolingId || filter.config.id)] = filter.selectedValues);
        });
        Object.entries(this.updates.schedule).map(([scheduleKey, value]) => {
          this.productsSelected.map(product => product.schedule[scheduleKey] = value);
        });
      },
      deep: true
    }
  }
};
